import { PhExceptionErrorType } from '@core/enums/ph-exception-error-type.enum';

export const PaymentErrorTypes: PhExceptionErrorType[] = [
  PhExceptionErrorType.PaymentTransactionFailedException,
  PhExceptionErrorType.PaymentTransactionFailedHardException,
  PhExceptionErrorType.PaymentTransactionFailedNoneException,
  PhExceptionErrorType.PaymentTransactionFailedSoftException,
  PhExceptionErrorType.PaymentTransactionFailedUnrecognizedException,
];
